import { Clerk } from '@clerk/clerk-js';

export let clerk = new Clerk(import.meta.env.VITE_REACT_APP_CLERK_PUBLISHABLE_KEY);
export const clerkPubKey = import.meta.env.VITE_REACT_APP_CLERK_PUBLISHABLE_KEY;

const initialClerkLoad = clerk.load.bind(clerk);

clerk.load = async () => {
  let retries = 0;
  let maxRetries = 5;
  let retryInterval = 1000;
  let loadTimeout = 5000;

  let loadWithRetry = async () => {
    while (retries < maxRetries) {
      try {
        // Create a timeout promise that rejects after the specified time
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('Clerk load timeout')), loadTimeout);
        });

        const initialLoadResult = await Promise.race([initialClerkLoad(), timeoutPromise]);

        return initialLoadResult;
      } catch (error) {
        retries++;
        console.warn(`Clerk load attempt ${retries} failed:`, error.message);

        await new Promise((resolve) => setTimeout(resolve, retryInterval));
      }
    }
    throw new Error(`Clerk failed to load after ${maxRetries} attempts`);
  };
  return await loadWithRetry();
};
